<template>
    <div class="attention-to-details flex mt-1 xl:flex-no-wrap xl:flex-row md:flex-wrap md:flex-col">
        <div class="attention-to-details-left py-4 xl:w-1/2 md:w-full">
            <p class="text-14 leading-spc5 text-white font-medium">
                Autopilot hardware seamlessly integrates with the sleek exterior.
            </p>
        </div>
        <div class="attention-to-details-right xl:pt-4 xl:pl-4 xl:w-1/2 md:w-full md:pl-0 md:pt-0">
            <div class="attention-to-details-img-box">
                <img src="../../../assets/images/detail3.jpg" alt="">
                <p class="text-14 leading-spc5 text-white font-medium pt-4">
                    A spoiler provides Model X with incredible aerodynamics and the lowest drag coefficient of any vehicle in its class.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ExteriorAttentionDetailBottom"
    }
</script>

<style scoped>

</style>